<template>
  <div class="range-container">
    <div class="date-container">
      <div class="date">
        <img
          src="@shared/assets/img/table/calendar-black.svg"
          class="calendar"
        >
        <span>{{ getDateV2(newSelectedDate.start) }}</span>
      </div>
    </div>
    <div class="line-divider" />
    <div class="date-container">
      <div class="date">
        <img
          src="@shared/assets/img/table/calendar-black.svg"
          class="calendar"
        >
        <span>{{ getDateV2(newSelectedDate.end) }}</span>
      </div>
      <div class="date-picker">
        <Datepicker
          v-model="newSelectedDate"
          mode="range"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import userActivitiesMixin from '@shared/mixins/userActivitiesMixin';

export default {
  name: 'DateRangeFilter',
  components: {
    Datepicker,
  },
  mixins: [
    userActivitiesMixin,
  ],
  data() {
    return {
      newSelectedDate: {
        start: null,
        end: null,
      },
    };
  },
  watch: {
    newSelectedDate(newValue) {
      this.changeUserActivityValues([{
        field: 'selectedDate',
        value: newValue,
      }]);
      this.$store.dispatch('getUserActivities');
    },
  },
};

</script>
<style lang="scss">

.range-container {
  display: flex;
  position: relative;
  margin-top: 12px;
  margin-bottom: 8px;

  .date-container {
    .header {
      font-size: 12.64px;
      margin-bottom: 6px;
    }

    .date {
      display: flex;
      align-items: center;
      padding-left: 9px;
      padding-right: 9px;
      width: 107px;
      height: 32px;
      background-color: $NBLUE10;
      font-size: 12.64px;

      .calendar {
        width: 15px;
        height: 15px;
        margin-right: 8px;
      }

      span {
        width: 100%;
        text-align: center;
      }
    }
  }

  .line-divider {
    width: 34px;
    height: 1px;
    background-color: $BLACK;
    margin-left: 11px;
    margin-right: 11px;
    margin-top: 40px;
  }

  .date-picker {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;

    input {
      opacity: 0;
    }
  }
}
</style>
